import React, { useState } from 'react';
import Cookies from 'js-cookie';
import { useHistory } from 'react-router-dom';

const setCookie = () => {
  Cookies.set('cookie.policy', '1', {
    expires: 365,
    sameSite: 'strict',
    secure: window.location.protocol === 'https:',
  });
};

const CookiePolicy = () => {
  const [read, setRead] = useState(
    Cookies.get('cookie.policy') === '1',
  );
  const history = useHistory();

  if (read) return '';

  return (
    <div
      className="fixed-bottom w-100 container-fluid"
    >
      <div className="row">
        <div className="col py-3 bg-primary text-white">
          This website uses cookies to ensure you get the best experience on our website.
          <a
            className="text-white mx-2 text-nowrap"
            onClick={() => history.push('/auth/privacy-policy')}
          >
            <u>Learn more</u>
          </a>
        </div>
        <a
          className="col-auto d-flex px-4 py-3 bg-secondary"
          onClick={() => {
            setCookie();
            setRead(true);
          }}
        >
          <div className="my-auto">
            Got it!
          </div>
        </a>
      </div>
    </div>
  );
};

export default CookiePolicy;
